import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  header: {
    height: "66px",
    position: "relative",
    zIndex: "9",
    "& .navbar-brand": {
      "& .clinksBeta": {
        verticalAlign: "sub",
        lineHeight: "1",
        position: "relative",
        bottom: "-5px",
        marginLeft: "4px",
        fontSize: "15px",
        fontWeight: "600",
        textTransform: "uppercase",
        color: "#fff",
      },
    },
  },
});
